module.exports = __webpack_public_path__ + "static/img/paback.0edb881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page7/paback.png
// module id = byQ4
// module chunks = 0